import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from '@src/app/app.module';
import { EnvironmentConfig, parseEnvironmentConfig } from 'src/app/configs/environment.config';

fetch('/assets/environment-config.json')
  .then(response => response.json())
  .then((loadedConfig) => {
    platformBrowserDynamic([{
      provide: EnvironmentConfig,
      useValue: parseEnvironmentConfig(loadedConfig),
    }]).bootstrapModule(AppModule).catch(err => console.log(err));
  });
